var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    class: "fill-current text-".concat(_vm.color),
    attrs: {
      "height": "".concat(_vm.height, "px"),
      "width": "".concat(_vm.width, "px"),
      "viewBox": "0 0 19 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.70248 0.755432C2.08165 0.755432 0.7677 2.06938 0.7677 3.69021V16.3098C0.7677 17.9306 2.08165 19.2446 3.70248 19.2446H14.1576C15.7785 19.2446 17.0924 17.9306 17.0924 16.3098V14.86C18.2478 14.0274 19 12.6702 19 11.1372C19 9.60429 18.2478 8.24704 17.0924 7.41443V3.69021C17.0924 2.06938 15.7785 0.755432 14.1576 0.755432H3.70248ZM15.625 8.26273V8.27581H15.6556C16.7602 8.75558 17.5326 9.85619 17.5326 11.1372C17.5326 12.8594 16.1366 14.2554 14.4144 14.2554C12.6923 14.2554 11.2962 12.8594 11.2962 11.1372C11.2962 9.41509 12.6923 8.01902 14.4144 8.01902C14.8438 8.01902 15.2528 8.10578 15.625 8.26273ZM15.625 6.71312V3.69021C15.625 2.8798 14.9681 2.22282 14.1576 2.22282H3.70248C2.89207 2.22282 2.23509 2.8798 2.23509 3.69021V16.3098C2.23509 17.1202 2.89206 17.7772 3.70248 17.7772H14.1576C14.9681 17.7772 15.625 17.1202 15.625 16.3098V15.5613C15.2394 15.6666 14.8335 15.7228 14.4144 15.7228C11.8819 15.7228 9.82884 13.6698 9.82884 11.1372C9.82884 8.60467 11.8819 6.55163 14.4144 6.55163C14.8335 6.55163 15.2394 6.60783 15.625 6.71312ZM16.4093 9.65966C16.5972 9.82939 16.612 10.1194 16.4423 10.3073L14.2229 12.7652C14.0559 12.9501 13.7719 12.9679 13.5832 12.8053L12.3909 11.7781C12.1991 11.6128 12.1775 11.3233 12.3428 11.1314C12.5081 10.9395 12.7977 10.918 12.9896 11.0833L13.8424 11.8181L15.7616 9.69268C15.9313 9.50471 16.2213 9.48993 16.4093 9.65966ZM12.0299 3.83695H5.86688V5.30435H12.0299V3.83695Z"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }